import Model from './Model'

export default class Vehicule extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            bihr_id: null,
            vehicule_brand_id: null,
            name: null,
            year: null,
            cylinder: null,
            model: null,
        }
    }

}
